/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { Fragment } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import upperFirst from 'lodash/upperFirst';

import Heading from '@atlaskit/heading/heading';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import { token } from '@atlaskit/tokens';

import SubGroup from './components/subgroup';
import groupedTokens from './grouped-tokens';

const listStyleReset: import('@emotion/utils').SerializedStyles = css({
	margin: 0,
	padding: 0,
	listStyle: 'none',
});

const displayHeadingContainerStyles = xcss({
	marginBlockEnd: 'space.200',
});

const rampStyles = css({
	marginBlockEnd: token('space.500'),
});

/**
 * __Color palette ramps__.
 *
 * Color palette ramps visually display color tokens.
 */
const ColorPaletteRamps = (): React.JSX.Element =>
	groupedTokens.length > 0 ? (
		<ul css={listStyleReset}>
			{groupedTokens.map((group) => (
				<li key={group.name} css={rampStyles}>
					{group.name && group.name !== 'colors' && (
						<Box xcss={displayHeadingContainerStyles}>
							<Heading size="medium">{upperFirst(group.name)}</Heading>
						</Box>
					)}
					{group.subgroups.length > 0 && <SubGroup {...group} />}
				</li>
			))}
		</ul>
	) : (
		<Fragment></Fragment>
	);

export default ColorPaletteRamps;
